import { get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { Small, Medium, LargeUp } from 'components/MediaQuery';
import { mediumUp } from 'constants/mediaQueries';
import Theme from 'styles/theme';

import RowsDesktop from './RowsDesktop';
import RowsMobile from './RowsMobile';

class SustainabilityPageShowcase extends React.Component {
  constructor(props) {
    super(props);
    this.state = { activeRowIndex: 0 };
  }

  handleRowTransition = index => {
    this.setState({ activeRowIndex: index });
  };

  render() {
    const { data, trackEvent } = this.props;
    const { activeRowIndex } = this.state;
    const items = get(data, 'items');

    return (
      <div className="SustainabilityPageShowcase">
        <Small>
          <RowsMobile
            rows={items}
            activeRowIndex={activeRowIndex}
            handleRowTransition={this.handleRowTransition}
            trackEvent={trackEvent}
          />
        </Small>
        <Medium>
          <RowsMobile
            rows={items}
            activeRowIndex={activeRowIndex}
            handleRowTransition={this.handleRowTransition}
            trackEvent={trackEvent}
          />
        </Medium>
        <LargeUp>
          <RowsDesktop
            rows={items}
            rowRefs={this.rowRefs}
            activeRowIndex={activeRowIndex}
            handleRowTransition={this.handleRowTransition}
            trackEvent={trackEvent}
          />
        </LargeUp>

        <style jsx>
          {`
            .SustainabilityPageShowcase {
              padding: ${Theme.get('spacing') * 9}px 0;
            }

            @media ${mediumUp} {
              .SustainabilityPageShowcase__item {
                padding-bottom: ${Theme.get('spacing') * 10}px;
              }

              .SustainabilityPageShowcase__item:last-child {
                padding-bottom: 0;
              }
            }
          `}
        </style>
      </div>
    );
  }
}

SustainabilityPageShowcase.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      desktopImage: PropTypes.shape({
        src: PropTypes.string.isRequired,
        alt: PropTypes.string,
      }).isRequired,
      mobileImage: PropTypes.shape({
        src: PropTypes.string.isRequired,
        alt: PropTypes.string,
      }).isRequired,
      heading: PropTypes.string.isRequired,
      subtext: PropTypes.string.isRequired,
      ctaLinks: PropTypes.arrayOf(
        PropTypes.shape({
          _contentType: PropTypes.string.isRequired,
          internalName: PropTypes.string.isRequired,
          text: PropTypes.string.isRequired,
          url: PropTypes.string.isRequired,
          openInNewWindow: PropTypes.bool.isRequired,
        })
      ),
    })
  ).isRequired,
  trackEvent: PropTypes.func,
};

SustainabilityPageShowcase.defaultProps = {
  trackEvent: () => {},
};

export default SustainabilityPageShowcase;
